<template>
  <form
    id="transaction-history-search-form"
    @submit.prevent="searchTransactionHistory"
    v-if="isPermittedAll([
      'HistoryGetAll'
    ])">
    <v-container class="px-5">
      <!-- Call -->
      <v-row>
        <v-col class="pt-0">
          <h3 class="mb-3">Filter</h3>
          <label for="search-transaction-history-entity">Entity:</label>
          <Autocomplete
            id="search-transaction-history-entity"
            :items="$store.state.transactionHistoryEntities"
            v-model="transactionHistorySearchParameters.Entity"
            @input="$store.commit(
              'setSearchParameters',
              { params: {
                Entity: transactionHistorySearchParameters.Entity,
              }, paramsKey: 'transactionHistorySearchParameters' },
            )"
            outlined
            filled>
          </Autocomplete>
        </v-col>
      </v-row>
      <!-- / Call -->

      <!-- User -->
      <v-row>
        <v-col>
          <label for="search-transaction-history-user">User:</label>
          <Autocomplete
            id="search-transaction-history-user"
            :items="$store.state.allUsers"
            v-model="userSearchParameter"
            item-value="UserID"
            item-text="UserGivenName"
            outlined
            filled
            include-any>
          </Autocomplete>
        </v-col>
      </v-row>
      <!-- / User -->

      <!-- Date Range Start -->
      <v-row>
        <v-col>
          <label for="search-transaction-history-start">Start:</label>
          <DatePicker
            input-id="search-transaction-history-start"
            :line-bottom="false"
            v-model="transactionHistorySearchParameters.StartDateUtc"
            @input="$store.commit(
              'setSearchParameters',
              { params: {
                StartDateUtc: transactionHistorySearchParameters.StartDateUtc,
              }, paramsKey: 'transactionHistorySearchParameters' },
            )"
          />
        </v-col>
      </v-row>
      <!-- / Date Range Start -->

      <!-- Date Range End -->
      <v-row>
        <v-col>
          <label for="search-transaction-history-end">End:</label>
          <DatePicker
            input-id="search-transaction-history-end"
            :line-bottom="false"
            v-model="end"
          />
        </v-col>
      </v-row>
      <!-- / Date Range End -->

      <!-- Search -->
      <v-row>
        <v-col>
          <v-btn
            type="submit"
            color="success"
            outlined
            block
            :disabled="$store.getters.isLoadingActive">
            Search Transactions
          </v-btn>
        </v-col>
      </v-row>
      <!-- / Search -->
    </v-container>
  </form>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import DatePicker from './DatePicker.vue';

export default {
  name: 'TransactionHistorySearchForm',
  components: {
    DatePicker,
  },
  computed: {
    /* Parameters */
    userSearchParameter: {
      get() {
        let user = _.find(
          this.$store.state.allUsers,
          { UserID: this.transactionHistorySearchParameters.UserID },
        );

        if (!user) {
          user = {
            UserID: undefined,
            UserGivenName: this.anyOption,
          };
        }

        return _.pick(user, ['UserID', 'UserGivenName']);
      },
      set(userSearchParameter) {
        const params = {
          UserID: userSearchParameter.UserID || undefined,
        };

        this.$store.commit(
          'setSearchParameters',
          { paramsKey: 'transactionHistorySearchParameters', params },
        );
      },
    },
    end: {
      get() {
        return this.transactionHistorySearchParameters.EndDateUtc;
      },
      set(end) {
        const params = {
          EndDateUtc: undefined,
        };

        if (end) {
          params.EndDateUtc = moment(end)
            .endOf('day')
            .format('YYYY-MM-DD[T]HH:mm:ssZ');
        }

        this.$store.commit(
          'setSearchParameters',
          { paramsKey: 'transactionHistorySearchParameters', params },
        );
      },
    },
    /* / Parameters */

    transactionHistorySearchParameters() {
      return this.$store.state.transactionHistorySearchParameters;
    },
  },
  methods: {
    searchTransactionHistory() {
      this.$store.dispatch('getTransactionHistory');
    },
  },
  created() {
    this.$store.dispatch('getTransactionHistoryEntities');
    this.$store.dispatch('getAllUsers');
  },
};
</script>

<style lang="scss"></style>
